import { useMutation } from '@tanstack/react-query';
import dataService from 'services/dataService';
import { showResult } from 'infrastructure/hooks/utils';
import { useEffect } from 'react';

import type { ModuleType } from 'infrastructure/enums';
import type { PatientReportExportCol } from 'components/organisms/provider-dashboard/utils';

export interface IExportPatientReportArgs {
  module: ModuleType;
  col: PatientReportExportCol;
  startDate: string;
  endDate: string;
  clinicGuid?: string[];
  parentClinicGuid?: string[];
  providerGuid?: string;
}

const exportFn = async ({
  module,
  col,
  ...filters
}: IExportPatientReportArgs) => {
  const url = `core-2/provider-dashboard/patient-reports/${module}/export`;

  const { data, error } = await dataService.createOne<{ response: string }>(
    url,
    { ...filters, col },
  );

  if (error) {
    return Promise.reject(error);
  }

  return data;
};

export const useExportPatientReport = () => {
  const { mutate, isLoading, variables, error } = useMutation<
    { response: string } | undefined,
    string | undefined,
    IExportPatientReportArgs
  >({
    mutationFn: exportFn,
  });

  useEffect(() => {
    if (error) {
      showResult(error);
    }
  }, [error]);

  return {
    exportColumn: mutate,
    isExporting: isLoading,
    exportingCol: isLoading ? variables?.col : undefined,
  };
};
